var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3800_7177)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M7.10938 10.7656H4.0625C2.37976 10.7656 1.01562 12.1298 1.01562 13.8125V21.9375C1.01562 23.6202 2.37976 24.9844 4.0625 24.9844H7.10938C5.42664 24.9844 4.0625 23.6202 4.0625 21.9375V13.8125C4.0625 12.1298 5.42664 10.7656 7.10938 10.7656Z",
    fill: "url(#paint0_linear_3800_7177)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 20.9219C15.2437 20.9219 17.0625 19.103 17.0625 16.8594C17.0625 14.6157 15.2437 12.7969 13 12.7969C10.7563 12.7969 8.9375 14.6157 8.9375 16.8594C8.9375 19.103 10.7563 20.9219 13 20.9219Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9219 10.7656V8.73438M13 1.01562V3.04688M6.90625 1.01562L8.9375 3.04688M19.0938 1.01562L17.0625 3.04688M15.0312 6.70312C16.1531 6.70312 17.0625 7.61257 17.0625 8.73438C17.0625 9.85618 17.9719 10.7656 19.0938 10.7656H21.9375C23.6202 10.7656 24.9844 12.1298 24.9844 13.8125V21.9375C24.9844 23.6202 23.6202 24.9844 21.9375 24.9844H4.0625C2.37976 24.9844 1.01562 23.6202 1.01562 21.9375V13.8125C1.01562 12.1298 2.37976 10.7656 4.0625 10.7656H6.90625C8.02806 10.7656 8.9375 9.85618 8.9375 8.73438C8.9375 7.61257 9.84694 6.70312 10.9688 6.70312H15.0312Z",
    stroke: "url(#paint1_linear_3800_7177)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3800_7177",
    x1: 1.01562,
    y1: 10.7656,
    x2: 11.7588,
    y2: 17.1043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3800_7177",
    x1: 1.44445,
    y1: -1.67943,
    x2: 29.1602,
    y2: 24.3093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3800_7177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraWhite);
export default __webpack_public_path__ + "static/media/cameraWhite.56c8bc30c1efb86e7910671d5c045906.svg";
export { ForwardRef as ReactComponent };